<template>
  <section class="dynamic-box">
    <Title :title="dynamicData.name + '的动态'" />
    <ul class="moment-ul">
      <li class="moment-li"
          v-for="(item, index) in dynamicData.list"
          v-if="item.moment.contentType === 'PICTURE'"
          :key="item.moment.id">
        <p>{{ !!item.moment.text.trim().length ? item.moment.text : '美照福利来啦～'  }}</p>
        <article class="moment-img-box">
          <img class="moment-img"
               v-for="(photo, i) in item.moment.photos"
               :src="photo.url"
               :key="i"
               width="100%"/>
        </article>
      </li>
    </ul>
  </section>
</template>
<script>
  import { mapGetters } from 'vuex'
  import Title from '@/components/TitleM'

  export default {
    // 服务器端渲染，预加载模特动态页面数据
    asyncData ({ store, route }) {
      return store.dispatch('getDynamicData', route.params.name)
    },
    components: { Title },
    computed: {
      ...mapGetters({
        dynamicData: 'dynamicData'
      }),
    }
  }
</script>
<style lang="scss" scoped>
  .moment-ul {
    list-style: none;
  }
  .moment-li {
    margin-bottom: 25px;
    p {
      margin-bottom: 10px;
    }
  }
  .moment-img-box {
    column-count: 2;
    column-gap: 10px;
    .moment-img {
      break-inside: avoid;
      margin-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Moment.vue